<div style="display: flex; align-items: center; justify-content: space-between; margin: 20px 0px 10px;">
  <h2 class="cpo-section-title" style="margin: 0px !important; padding: 0px !important;">Manage Feature Flags</h2>
  <button style="cursor: pointer; margin-top: 0px;" class="btn-core toolbar-button" (click)="create()">Add Feature Flag</button>
</div>
<table [showLoadingSpinner]="loading" class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th class="no-sort">Flag name</th>
      <th class="no-sort">Enabled</th>
      <th class="no-sort">Actions</th>
    </tr>
  </thead>
  @for (item of featureFlags; track item; let i = $index) {
    <tr id="tr_view_{{ i }}" class="cpo-selectable-table__row">
      <td>{{ item.name }}</td>
      <td>{{ item.enabled }}</td>
      <td style="width: 20%;">
        <app-icon [style]="'cursor: pointer; margin-right: 30px;'" 
          [title]="'Edit brand name'" 
          [type]="item.enabled ? 'MinusRemove' : 'PlusAdd'"
          color="var(--color-action-icon)" 
          (click)="toggle(item)">
        </app-icon>
        <app-icon [style]="'cursor: pointer;'" title="Delete customer" [color]="'var(--color-action-icon-delete)'"
          (click)="delete(item)" type="Trash"></app-icon>
      </td>

    </tr>
  }
</table>

